module.exports = __webpack_public_path__ + "img/bule11.59c399b7.png";